import initialState from './initialState';
import {
  PASSWORD_RESET_FLAG
} from '../actions/actionConstants'


export default function PureActionReducer(state = initialState.pureActions, action) {

  switch (action.type) {
    case PASSWORD_RESET_FLAG:
      return Object.assign({}, state, { password_reset: action.flag })

    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/reducers/PureActionReducer.js